import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { KeyOperation } from '../models/KeyOperation';

export class KeyOperationMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): KeyOperation {
    return new KeyOperation(
      this.gqlIdEncoder.decode(data.id),
      this.gqlIdEncoder.decode(data.report.id),
      data.context,
      data.type,
      data.algorithms ?? [],
      data.keyRoles ?? []
    );
  }
}
